module.exports = __webpack_public_path__ + "static/media/sweet_4_tablet.ed5c405e.png";